<template>
  <banners :is-ultra="true">
    <div
      class="container-max m-auto"
      :class="{
        'min-h-[94vh] bg-steel-100': !isDesktop,
      }"
    >
      <div class="flex items-center justify-between bg-white px-3 pb-4 pt-8">
        <h1
          v-if="!isWebView"
          class="text-4xl"
        >
          Offers
        </h1>
      </div>

      <div class="flex gap-3">
        <OffersTable :is-desktop="isDesktop"></OffersTable>
      </div>

      <NotificationComponent
        v-show="showOfferNotification"
        title="Offer Updated"
        icon-type="success"
        @close="toggleOfferNotication"
      >
        <div class="text-left">
          <p class="mb-2 text-sm font-normal text-steel-800">
            Your offer was successfully updated.
          </p>
        </div>
      </NotificationComponent>
    </div>
  </banners>
</template>

<script setup>
import { onBeforeMount, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { Banners, NotificationComponent, OffersTable } from '@/components';
import { useScreenSize } from '@/composables';

const store = useStore();
const router = useRouter();
const { screenSize } = useScreenSize();

const isDesktop = computed(() => screenSize.value === 'desktop');

const isWebView =
  typeof window !== 'undefined' &&
  typeof window.ReactNativeWebView !== 'undefined';

onBeforeMount(async () => {
  const existingHash = router.currentRoute.value?.hash;

  const currentOffer = localStorage.getItem('current_offer');

  let currentOfferCompanyId;
  if (currentOffer) {
    currentOfferCompanyId = JSON.parse(currentOffer)?.load?.broker_company_id;
  }

  if (existingHash?.includes('#history')) {
    const historyRes = await store.dispatch('loads/getOffersByType', {
      type: 'history',
    });

    if (historyRes?.data) {
      store.dispatch('loads/getOffersByCompanyId', {
        company_id: currentOfferCompanyId || historyRes?.data?.[0]?.company_id,
        type: 'history',
      });
    }

    await store.dispatch('loads/getOffersByType', {
      type: 'waiting',
    });
    await store.dispatch('loads/getOffersByType', {
      type: 'actions',
    });
  } else if (existingHash === '#waiting') {
    const waitingRes = await store.dispatch('loads/getOffersByType', {
      type: 'waiting',
    });

    if (waitingRes?.data) {
      store.dispatch('loads/getOffersByCompanyId', {
        company_id: waitingRes?.data?.[0]?.company_id,
        type: 'waiting',
      });
    }

    await store.dispatch('loads/getOffersByType', {
      type: 'actions',
    });
    await store.dispatch('loads/getOffersByType', {
      type: 'history',
    });
  } else {
    const actionsRes = await store.dispatch('loads/getOffersByType', {
      type: 'actions',
    });

    if (actionsRes?.data) {
      store.dispatch('loads/getOffersByCompanyId', {
        company_id: actionsRes?.data?.[0]?.company_id,
        type: 'actions',
      });
    }

    await store.dispatch('loads/getOffersByType', {
      type: 'waiting',
    });
    await store.dispatch('loads/getOffersByType', {
      type: 'history',
    });
  }
});

const showOfferNotification = ref(false);
const toggleOfferNotication = () => {
  showOfferNotification.value = !showOfferNotification.value;
};
</script>
